<div class="progress-loader" id="background-loader" [hidden]="!loading">
  <h1>Aguarde...</h1>
  <div class="spinner">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
</div>
